import { render, staticRenderFns } from "./Sectors.vue?vue&type=template&id=7b63f674"
import script from "./Sectors.vue?vue&type=script&lang=js"
export * from "./Sectors.vue?vue&type=script&lang=js"
import style0 from "./Sectors.vue?vue&type=style&index=0&id=7b63f674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports